<template>
  <v-container >
    <v-col  cols="12"  sm="6"   class="py-2">
          <v-flex   xs12 md3 class="py-0" >
              <v-btn v-on:click="test('Less than 94')"  @click="type1=2,type2=1,type3=1" block   v-bind:color="type1 === 1 ? 'light-blue accent-2' : 'light-blue darken-4'"><h4 class="text-capitalize font-weight-medium">Less than 94</h4> </v-btn>
          </v-flex>
          <v-flex xs12 md3 class="py-0">
             <v-btn  v-on:click="test('Between 95 and 102')" @click="type2=2,type1=1,type3=1" block   v-bind:color="type2 === 1 ? 'light-blue  accent-2' : 'light-blue darken-4'"><h4 class="text-capitalize font-weight-medium"> Between 95 and 102</h4> </v-btn>
          </v-flex>
          <v-flex xs12 md3 class="py-0">
             <v-btn  v-on:click="test('More than 102')" @click="type3=2,type1=1,type2=1" block   v-bind:color="type3 === 1 ? 'light-blue  accent-2' : 'light-blue darken-4'"><h4 class="text-capitalize font-weight-medium"> More than 102</h4> </v-btn>
          </v-flex>
     </v-col>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        text: 'center',
        icon: 'justify',
        type1:1,
        type2:1,
        type3:1,
      }

    },
     methods: {
         test:function(value){
                    this.$emit('change',value)

         }
      }

  }
</script>
